// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W7Yl","top":"styles_top__2hlR4"};